export const OBSERVATION_OWNER_EXTERNAL = 'external';
export const OBSERVATION_OWNER_INTERNAL = 'internal';

const OWNER_SORT_PRIORITY = {
  [OBSERVATION_OWNER_EXTERNAL]: 0,
  null: 1,
  [OBSERVATION_OWNER_INTERNAL]: 2
};

const extractOwnerNameFromLabel = (label) => {
  if (!label) return null;
  const match = label.match(/Esperando acci[oó]n de:\s*(.+)/i);
  return match?.[1]?.trim() || null;
};

export const getObservationOwnerContext = (observation) => {
  if (!observation || observation.status !== 'open') {
    return {
      owner: null,
      isCommercialTurn: false,
      isLenderTurn: false,
      isUnassigned: false,
      badgeLabel: null,
      badgeTitle: null,
      cardModifier: null,
      sortPriority: 3
    };
  }

  const owner = observation.action_owner ?? null;
  const isCommercialTurn = owner === OBSERVATION_OWNER_EXTERNAL;
  const isLenderTurn = owner === OBSERVATION_OWNER_INTERNAL;
  const isUnassigned = owner === null;
  const badgeTitle = observation.action_owner_label || null;

  let badgeLabel = null;
  if (isCommercialTurn) {
    badgeLabel = 'Tu acción';
  } else if (isLenderTurn) {
    const lenderName = extractOwnerNameFromLabel(badgeTitle);
    badgeLabel = lenderName ? `En financiera · ${lenderName}` : 'En financiera';
  } else if (isUnassigned) {
    badgeLabel = 'Sin responsable';
  }

  return {
    owner,
    isCommercialTurn,
    isLenderTurn,
    isUnassigned,
    badgeLabel,
    badgeTitle,
    cardModifier: isCommercialTurn
      ? 'commercial-turn'
      : isLenderTurn
        ? 'lender-turn'
        : isUnassigned
          ? 'owner-unassigned'
          : null,
    sortPriority: OWNER_SORT_PRIORITY[owner ?? 'null'] ?? 1
  };
};

export const sortRequestsByObservationOwner = (requests) => (
  [...requests].sort((left, right) => {
    const leftPriority = getObservationOwnerContext(left.relevant_observation).sortPriority;
    const rightPriority = getObservationOwnerContext(right.relevant_observation).sortPriority;

    if (leftPriority !== rightPriority) {
      return leftPriority - rightPriority;
    }

    const leftUpdated = new Date(left.updated_at || 0).getTime();
    const rightUpdated = new Date(right.updated_at || 0).getTime();
    return rightUpdated - leftUpdated;
  })
);
